// style
import { IconBrandInstagram, IconBrandTelegram, IconBrandWhatsapp, IconBrandYoutube, IconClock, IconMail, IconPhone } from '@tabler/icons-react';
import './style/footer.css'
import { Link, NavLink } from 'react-router';
import { RoutesClient } from '../../features/routes/routes';
const Footer = () => {
    return (
        <>
            <footer className="bg-dark py-5 pb-3">
                <section className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <Link to="/">
                                <img src={require('./../../assets/media/logo/final.png')} alt="logo" className="brand-logo" />
                            </Link>
                            <p className='mb-0 card-text text-white mt-3'>
                                ارس کام، جایی که زیبایی، اصالت و کیفیت در کنار هم قرار می‌گیرند. ما با ارائه محصولات اصل از برندهای معتبر، تضمین اصالت کالا و پشتیبانی حرفه‌ای، تجربه‌ای مطمئن و لذت‌بخش از خرید محصولات آرایشی و بهداشتی را برای شما فراهم می‌کنیم.                            </p>
                        </div>
                        <div className="col-lg-3 text-lg-start text-center d-lg-inline-block d-none ps-5">
                            <h6 className='text-white  h5 fw-bold'>لینک های مفید</h6>
                            <ul className='list-group px-0'>
                                {RoutesClient.map((link) => (
                                    <>
                                        {link.show && link.footer === true ? (
                                            <li className='list-group-item px-0'>
                                                <>
                                                    <NavLink className="text-white text-decoration-none" to={link.address}>
                                                        {link.label}
                                                    </NavLink>
                                                </>
                                            </li>
                                        ) : null}
                                    </>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-3 d-lg-inline-block d-none ps-5">
                            <h6 className='text-white h5 fw-bold'>تماس با ما</h6>
                            <ul className='list-group px-0'>
                                <li className='list-group-item px-0'>
                                    <NavLink className="text-white text-decoration-none" to={'https://t.me/arascome'}>
                                        تلگرام
                                    </NavLink>
                                </li>
                                <li className='list-group-item px-0'>
                                    <NavLink className="text-white text-decoration-none" to={'https://wa.me/+989373739843'}>
                                        واتساپ
                                    </NavLink>
                                </li>
                                <li className='list-group-item px-0'>
                                    <NavLink className="text-white text-decoration-none" to={'#'}>
                                        ایتا
                                    </NavLink>
                                </li>
                                <li className='list-group-item px-0'>
                                    <NavLink className="text-white text-decoration-none" to={'https://www.instagram.com/arascome?igsh=MTBpN2l1NDRjZXg3Mw=='}>
                                        اینستاگرام
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-3 d-lg-inline-block d-none ps-5">
                            <h6 className='text-white h5 fw-bold'>جواز ها</h6>
                            <div className='bg-white rounded rounded-4 p-3' style={{ width: '135px' }}>
                                {/* @ts-ignore */}
                      <img referrerPolicy='origin' src={require('./../../assets/media/logo/enamad.jpg')} alt='enamad' style={{ cursor: 'pointer', width: '100px', height: '100px', objectFit: 'cover' }} />
                            </div>
                        </div>
                    </div>
                    <div className="connection-box py-3 pb-2 mt-3">
                        <div className="details">
                            <div className='d-flex align-items-center'>
                                <span className='text-white px-4 w-25 fw-bold d-lg-inline-block d-none'>راه های ارتباطی با ارس کام</span>
                                <div className='card card-body footer-card py-4 w-100'>
                                    <div className='row justify-content-center gy-3'>
                                        <div className='col-md-4 text-center'>
                                            <div className='d-flex align-items-center justify-content-md-center justify-content-end'>
                                                <span className='fw-bold font-large'>شنبه تا پنجشنبه از 10</span>
                                                <div className='bg-black bg-icon rounded-circle ms-2'>
                                                    <IconClock className='text-white align-middle' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-4 text-center '>
                                            <div className='d-flex align-items-center justify-content-md-center justify-content-end'>
                                                <span className='fw-bold font-large'>arascome@gmail.com</span>
                                                <div className='bg-black bg-icon rounded-circle ms-2'>
                                                    <IconMail className='text-white align-middle' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-4 text-center'>
                                            <div className='d-flex align-items-center justify-content-md-center justify-content-end'>
                                                <span className='fw-bold font-large'>021-66653976</span>
                                                <div className='bg-black bg-icon rounded-circle ms-2'>
                                                    <IconPhone className='text-white align-middle' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="social d-flex justify-content-center text-white mb-0 py-4 pb-0">
                            <IconBrandInstagram size={32} />
                            <IconBrandTelegram size={32} className=' mx-3' />
                            <IconBrandWhatsapp size={32} className='me-3' />
                            <IconBrandYoutube size={32} />
                        </div>
                    </div>
                </section>
            </footer>
        </>
    )
}

export default Footer;